import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, leftJoin, nullsafe, unionKey } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { MotivoGuiaItem } from "./model";

/**Convierte la lista de guias y los motivos a un listado de items del listado de guias */
export function toItems(guias: models.GuiaDTO[], motivos: models.MotivoCancelacionGuiaModel[]): MotivoGuiaItem[] {
    return (
        leftJoin(guias, motivos, (g, m) => g.IdRegistro == m.IdGuia)
            .map<MotivoGuiaItem>(x => ({
                ...x.left,
                IdGuia: x.left.IdRegistro,
                MotivoCancelacion: nullsafe(x.right, x => x.MotivoCancelacion)
            }))
    );
}

/**Aplica un onChange al arreglo de los motivos*/
export function onChange(idGuia: number, motivo: string, value: models.MotivoCancelacionGuiaModel[]): models.MotivoCancelacionGuiaModel[] {
    return unionKey(value, [{
        IdGuia: idGuia,
        MotivoCancelacion: motivo
    }], x => x.IdGuia).filter(x => !!x.MotivoCancelacion);
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/facturas/cancelacion/list/motivoguias/logic.tsx